// 查看会员信息 （券转赠记录）
<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>券转赠记录</h3>
            </div>
            <div class="card-button">
              <el-button
                class="push-button"
                icon="iconfont icon-fanhui"
                plain
                @click="NvagetToLookMenber"
                >返回基本信息</el-button
              >
            </div>
          </div>
          <div class="NumberTable">
            <div style="margin-bottom: 10px">赠送记录</div>
            <el-table
              height="calc(100vh - 38rem)"
              size="small"
              class="table-style"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                'text-align': 'center',
                color: '#6C6839',
                fontSize: '14px',
              }"
              :cell-style="{ 'text-align': 'center' }"
              :data="dataSource"
              tooltip-effect="dark"
              style="width: 100%"
              v-loading="Options.loading"
            >
              <el-table-column type="index" width="60"></el-table-column>
              <el-table-column width="200" prop="coupCode" label="券编码">
                <template slot-scope="scope">
                  <div class="link--inner" @click="look(scope.row)">
                    {{ scope.row.coupCode }}（查看）
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="160"
                prop="couponsName"
                label="券名称"
              ></el-table-column>
              <el-table-column
                width="120"
                prop="coupValue"
                label="券值"
              ></el-table-column>
              <el-table-column
                width="120"
                prop="transferCustName"
                label="赠送人"
              ></el-table-column>
              <el-table-column
                width="120"
                prop="receiverCustName"
                label="接收人"
              ></el-table-column>
              <el-table-column width="120" prop="couponsKind" label="券类型">
                <template slot-scope="scope">
                  {{ couponsKindList[scope.row.couponsKind] }}
                </template>
              </el-table-column>
              <el-table-column width="120" prop="state" label="状态">
                <template slot-scope="scope">
                  {{ statList[scope.row.state] }}
                </template>
              </el-table-column>
              <el-table-column
                width="160"
                prop="startDate"
                label="生效起始日期"
              >
                <template slot-scope="scope">
                  {{ renderTime(scope.row.startDate || "") }}
                </template>
              </el-table-column>
              <el-table-column width="160" prop="endDate" label="生效终止日期">
                <template slot-scope="scope">
                  {{ renderTime(scope.row.endDate || "") }}
                </template>
              </el-table-column>
            </el-table>
            <div style="margin: 10px 0px">接收记录</div>
            <el-table
              height="calc(100vh - 38rem)"
              size="small"
              class="table-style"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                'text-align': 'center',
                color: '#6C6839',
                fontSize: '14px',
              }"
              :cell-style="{ 'text-align': 'center' }"
              :data="dataSourceTow"
              tooltip-effect="dark"
              style="width: 100%"
              v-loading="OptionsTow.loading"
            >
              <el-table-column type="index" width="60"></el-table-column>
              <el-table-column width="200" prop="coupCode" label="券编码">
                <template slot-scope="scope">
                  <div class="link--inner" @click="look(scope.row)">
                    {{ scope.row.coupCode }}（查看）
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="160"
                prop="couponsName"
                label="券名称"
              ></el-table-column>
              <el-table-column
                width="120"
                prop="coupValue"
                label="券值"
              ></el-table-column>
              <el-table-column
                width="120"
                prop="transferCustName"
                label="赠送人"
              ></el-table-column>
              <el-table-column
                width="120"
                prop="receiverCustName"
                label="接收人"
              ></el-table-column>
              <el-table-column width="120" prop="couponsKind" label="券类型">
                <template slot-scope="scope">
                  {{ couponsKindList[scope.row.couponsKind] }}
                </template>
              </el-table-column>
              <el-table-column width="120" prop="state" label="状态">
                <template slot-scope="scope">
                  {{ statList[scope.row.state] }}
                </template>
              </el-table-column>
              <el-table-column
                width="160"
                prop="startDate"
                label="生效起始日期"
              >
                <template slot-scope="scope">
                  {{ renderTime(scope.row.startDate || "") }}
                </template>
              </el-table-column>
              <el-table-column width="160" prop="endDate" label="生效终止日期">
                <template slot-scope="scope">
                  {{ renderTime(scope.row.endDate || "") }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
const statList = {
  0: "有效",
  1: "已核销",
  2: "已禁用",
  3: "未发放",
  4: "无效",
  5: "过期",
};
const couponsKindList = {
  0: "现金劵",
  1: "折扣劵",
  2: "礼品劵",
  3: "异业劵",
};
import { mapState } from "vuex";
import { transferRecord, receiveRecord } from "@/api/viewMemberModule";
// import { getcpyNo } from "@/utils/auth";
export default {
  name: "VoucherTransferRecord",
  data() {
    return {
      Options: {
        loading: false,
      },
      dataSource: [],

      OptionsTow: {
        loading: false,
      },
      dataSourceTow: [],

      statList,
      couponsKindList,
    };
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  mounted() {
    this.getInfoList();
    this.getInfoListTow();
  },
  methods: {
    look(row) {
      this.$store.dispatch("user/USetCouponsSelectChang", row);
      localStorage.setItem("CouponsSelectChang", JSON.stringify(row));
      this.$router.push("/IssuedSee");
    },
    getInfoList() {
      this.Options.loading = true;
      let data = require("qs").stringify({
        custID: this.custID,
      });
      transferRecord(data).then((res) => {
        if (res.success == true) {
          this.dataSource = res.data;
        } else {
          this.$message.error(res.message);
        }
        this.Options.loading = false;
      });
    },
    getInfoListTow() {
      this.OptionsTow.loading = true;
      let data = require("qs").stringify({
        custID: this.custID,
      });
      receiveRecord(data).then((res) => {
        if (res.success == true) {
          this.dataSourceTow = res.data;
        } else {
          this.$message.error(res.message);
        }
        this.OptionsTow.loading = false;
      });
    },
    renderTime(date) {
      if (date) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  margin-left: 25px;
  height: 990px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
/deep/.Enabledisable {
  .el-dialog__header,
  .el-message-box__header {
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    height: 44px;
    background: #f3f1dd;
    width: 100%;
    text-align: center;
    color: #666;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .el-dialog__title,
  .el-message-box__title {
    color: #6c6937;
    font-weight: 700;
    font-size: 16px !important;
  }
  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .coverage-release .el-dialog__body {
    padding: 20px;
  }
  .el-button:hover {
    background-color: #b6b388;
  }
  .el-dialog__body {
    padding: 30px 60px;
  }
  .el-tabs__item {
    border: 1px solid #d9d9d9;
    background-color: #fff;
    color: #6c6937;
  }
  .el-dialog__footer {
    height: 60px;
    text-align: center;
    background-color: #f2f2f2;
  }

  .el-tabs__item.is-active {
    color: #6c6937;
    background-color: #f3f1dd;
  }
  .el-form-item__content {
    line-height: 0px;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
}

.link--inner {
  cursor: pointer;
  color: #a19b59;
  text-decoration: underline;
}

// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
.demonstration {
  font-size: 14rpx;
  font-weight: 400;
  color: #333333;
}
.card-pagination {
  margin-top: 15px;
  height: 50px;
}
// 改变分页背景色
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #d1cda5 !important;
  color: #ffffff !important;
}
// 改变分页字体颜色
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  color: #d1cda5 !important;
}

::v-deep {
  // table隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5;
    color: #ffffff;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5;
  }
}
</style>
